import { useState, useEffect } from "react";
import { ListaFornecedor } from "../../components/fornecedor/lista/ListaFornecedor";
import { FornecedorService } from "../../services/fornecedor/fornecedor.service";
import { columnDescriptions } from "./columnDescriptions";
import { useAuth } from "../../contexts/AuthContext";
import { Alert } from "../shared/alert/Alert";

export const Fornecedor = () => {
  const { user } = useAuth();
  const storageKey = "supplierTableFilters";

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);

  useEffect(() => {
    localStorage.removeItem(storageKey);
    setColumnFilters([]);
  }, []);

  const handleFiltering = (filtros = []) => {
    setPage(1);
    setColumnFilters(filtros);
    localStorage.setItem(storageKey, JSON.stringify(filtros));
  };

  const fetchData = async (pageNumber = 1, pageSize = limit, filtros = columnFilters) => {
    if (!user?.token) return;

    setLoading(true);
    try {
      if (filtros.length > 0) {
        const payload = {
          filtros: filtros.map(f => ({
            campo: f.campo || f.id,
            valor: f.valor || f.value,
            uselike: f.uselike ?? true,
          })),
        };

        const response = await FornecedorService.filtrarFornecedores(
          user.token,
          payload,
          true,
          pageNumber,
          pageSize
        );

        const { docs = [], total: totalRecords = 0 } = response || {};
        setData(docs);
        setTotal(totalRecords);
      } else {
        const response = await FornecedorService.getFornecedores(
          user.token,
          true,
          pageNumber,
          pageSize
        );

        const { docs = [], total: totalRecords = 0 } = response || {};
        setData(docs);
        setTotal(totalRecords);

        if (docs.length && columns.length === 0) {
          const dynamicColumns = Object.keys(docs[0]).map(key => ({
            accessorKey: key,
            header: columnDescriptions[key],
          }));
          setColumns(dynamicColumns);
        }
      }
    } catch (error) {
      const message = error.response?.data?.erro || error.message;
      Alert({
        title: "Erro",
        message: `Não foi possível listar os fornecedores: ${message}`,
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!user?.token) return;

    fetchData(page, limit, columnFilters);
  }, [user?.token, page, limit, columnFilters]);

  return (
    <ListaFornecedor
      columns={columns}
      data={data}
      setData={setData}
      page={page}
      setPage={setPage}
      limit={limit}
      setLimit={setLimit}
      total={total}
      setTotal={setTotal}
      loading={loading}
      handleFiltering={handleFiltering}
      storageKey={storageKey}
      setLoading={setLoading}
      getRowStyle={(row) => {
        if (row.cliafa === "INATIVO") return { backgroundColor: "#f9e2e2ff" };
        return {};
      }}
      legend={[
        { color: "#988282ff", label: "Inativo" },
      ]}
    />
  );
};
